import { useEffect } from 'react';
import { postApi } from '@/util/request.js';
import s from './style.module.scss';
import { useStores } from '../../stores/storeContext';
import { useRouter } from 'next/router';
// import { useToast } from '@/stores/ToastContext';
// import { useTranslation } from 'react-i18next';

function GoogleLoginButton(props) {
  const isWing = props?.appType === 'wing';
  const isRetrieveData = props?.isRetrieveData;
  let clientId = '804533061477-os22qksvgd1qgrrdhvh6uusb8qooo400.apps.googleusercontent.com';
  if (isWing) {
    clientId = '293243973419-3mia7cg79s222fml63jil0km3smi1vv5.apps.googleusercontent.com';
  }
  // const t = useTranslation();
  const router = useRouter();
  const { rootStore } = useStores();
  // const showToast = useToast();
  const { updateKey } = rootStore;

  useEffect(() => {
    const initGoogle = () => {
      if (!window.google?.accounts?.id) return;
      window.google.accounts.id.initialize({
      client_id: clientId,
      callback: handleCredentialResponse,
    });

      const signInDiv = document.getElementById('signInDiv');
      if (signInDiv) {
        signInDiv.style.opacity = 0;
        window.google.accounts.id.renderButton(signInDiv, { theme: 'outline', size: 'large' });
      }
    };

    if (window.google?.accounts?.id) {
      initGoogle();
    } else {
      const timer = setInterval(() => {
        if (window.google?.accounts?.id) {
          clearInterval(timer);
          initGoogle();
        }
      }, 200);
      return () => clearInterval(timer);
    }
  }, []);

  async function handleCredentialResponse(response) {
    // console.log(`Encoded JWT ID token: ${response.credential}`);
    if (isRetrieveData) {
      // 账号删除/数据取回场景
      const res = await postApi(`${window.location.protocol}//${window.location.host}/web/account/support/thirdparty`, {
        grantType: 'google',
        thirdPartyAccessToken: response.credential,
      });
      if (res.meta?.code === 200) {
        if (res.data?.token) {
          updateKey('token', res.data?.token);
          return router.push('/log-entries/del-account');
        } else if (res.data?.deletedUser) {
          const deletedUser = res.data.deletedUser;
          updateKey('token', '');
          updateKey('deleteTime', deletedUser.deleteTime || res.data?.deleteTime);
          updateKey('deletedUserPhone', deletedUser.mobileNumber || '');
          updateKey('deletedUserEmail', deletedUser.email || '');
          updateKey('loginGrantType', 'google');
          updateKey('thirdpartyAccessToken', response.credential);
          return router.push('/log-entries/download-info');
        } else {
          return router.push('/log-entries/no-account');
        }
      } else {
        return router.push('/log-entries/no-account');
      }
    } else {
      // 登录/注册场景
      const res = await postApi(`${window.location.protocol}//${window.location.host}/web/account/login`, {
        grantType: 'google',
        thirdPartyAccessToken: response.credential,
      });
      if (res.meta?.code === 200 && res.data?.token) {
        updateKey('token', res.data?.token);
        return router.push('/log-entries/del-account');
      } else {
        return router.push('/log-entries/no-account');
      }
    }
  }

  return (
    // <div className={s.btnWrapper}>
    <div id="signInDiv" className={s.signInDiv} />
    // </div>
  );
}

export default GoogleLoginButton;
